import * as React from "react";
import { useIntl } from "@grandvisionhq/state";
import { logOrderEvent } from "../../../../../../data-layer/data-layer/orders.js";
import { useGetMyOrderHistory } from "../../../../../hooks/Orders/hooks/use-get-my-order-history.js";
import OrderList from "./OrderList.js";
const INITIAL_ORDERS = 5;
const ORDER_INTERVAL = 5;
const isValidCount = (count) => count && !isNaN(count) && count % ORDER_INTERVAL === 0;
const OrderListContainer = ({ shouldShowOrderDate }) => {
  const intl = useIntl();
  const { getLabel, getFormattedLabel, hasLabel } = intl;
  const [failedOrders, setFailedOrders] = React.useState(0);
  const url = typeof window !== "undefined" ? new URL(window.location.href) : void 0;
  const count = Number(url?.searchParams.get("count"));
  const initialCount = isValidCount(count) ? count : INITIAL_ORDERS;
  const [loadMoreClicked, setLoadMoreClicked] = React.useState(false);
  const onCompleted = React.useCallback(
    // This hook is called every time gql completes the request and returns the new data
    (data) => {
      if (!data) {
        return;
      }
      const orders2 = data.me?.orders?.results.length || 0;
      const newFailedOrders = data.me?.orders?.failures.length || 0;
      const totalFailedOrders = newFailedOrders + failedOrders;
      if (newFailedOrders > 0) {
        setFailedOrders(totalFailedOrders);
      }
      const count2 = orders2 + totalFailedOrders;
      if (isValidCount(count2) && loadMoreClicked) {
        const url2 = new URL(window.location.href);
        url2.searchParams.set("count", `${count2}`);
        window.history.replaceState(null, "", url2);
        setLoadMoreClicked(false);
      }
    },
    [failedOrders, loadMoreClicked]
  );
  const [
    { fetchMore },
    {
      data: { total, orders, loading, error }
    }
  ] = useGetMyOrderHistory({
    limit: initialCount,
    offset: 0,
    onCompleted
  });
  const onLoadMoreClick = React.useCallback(() => {
    logOrderEvent({
      event_type: "my_online_orders",
      event: "show_more_orders_click"
    });
    if (loading || orders.length >= total) {
      return;
    }
    setLoadMoreClicked(true);
    const url2 = new URL(window.location.href);
    const currentCount = Number(url2.searchParams.get("count")) || initialCount;
    fetchMore({
      variables: {
        limit: ORDER_INTERVAL,
        offset: currentCount
      }
    });
  }, [fetchMore, initialCount, loading, orders.length, total]);
  const onContactLinkClick = () => {
    logOrderEvent({
      event_type: "my_online_orders",
      event: "contact_form_click"
    });
  };
  const labels = {
    noHistory: getLabel("account.order.noHistory.message"),
    loadMore: getLabel("account.orders.showMore"),
    error: getFormattedLabel("account.common.error.contact", {
      parseLink: true,
      parseHTML: true
    }),
    productCategories: getLabel("account.orders.productCategories.title"),
    progressLabel: getFormattedLabel("account.orders.pagingStatus", {
      labelData: {
        total,
        loaded: orders.length
      }
    }),
    contactText: hasLabel("account.orders.footerText") ? getFormattedLabel("account.orders.footerText", {
      parseLink: true,
      openLinksInNewTab: true
    }) : ""
  };
  return /* @__PURE__ */ React.createElement(
    OrderList,
    {
      error,
      labels,
      loading,
      orders,
      ordersLoaded: orders.length,
      totalOrders: total,
      onLoadMoreClick,
      onContactLinkClick,
      shouldShowOrderDate
    }
  );
};
export {
  OrderListContainer as default
};
//# sourceMappingURL=OrderListContainer.js.map
